import { Grid, styled } from '@material-ui/core'
import { Typography } from 'components'
import { colors } from 'config'
import { getCurrentFont } from 'config/theme'
import Product from './Product'

export const Wrapper = styled(Grid)(({ theme }) => ({
  width: '100%',
  boxSizing: 'border-box',
  backgroundColor: colors.landing.background.paper,
  padding: theme.spacing(7.5, 19.5, 7, 19.5),
  alignItems: 'stretch',
  overflow: 'hidden',
  [theme.breakpoints.down('lg')]: {
    padding: theme.spacing(7.5, 14, 10, 14),
  },
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(7.5, 10, 8, 10),
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(5, 4.5, 5, 4.5),
  },
}))

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: 40,
  lineHeight: '40px',
  color: colors.landing.text.secondary,
  letterSpacing: 0.8375,
  fontWeight: 'bold',
  fontFamily: getCurrentFont('korolev, sans-serif'),
  [theme.breakpoints.down('md')]: {
    fontSize: 37,
    lineHeight: '37px',
  },
  [theme.breakpoints.down('sm')]: {
    lineHeight: '39px',
    fontSize: 37,
  },
}))

export const Hint = styled(Typography)(({ theme }) => ({
  fontSize: 28,
  fontFamily: getCurrentFont('korolev, sans-serif'),
  lineHeight: '63px',
  textTransform: 'uppercase',
  color: colors.landing.text.hint,
  letterSpacing: 0.35,
  fontWeight: 'bold',
  [theme.breakpoints.down('md')]: {
    fontSize: 24,
    lineHeight: '43px',
  },
  [theme.breakpoints.down('sm')]: {
    lineHeight: '23px',
    fontSize: 22,
    marginBottom: theme.spacing(),
  },
}))

export const Subtitle = styled(Typography)(({ theme }) => ({
  fontSize: 18,
  lineHeight: '24px',
  letterSpacing: 0.06,
  marginTop: theme.spacing(1.5),
  opacity: 0.85,
  [theme.breakpoints.down('sm')]: {
    fontSize: 15,
  },
}))

export const InfoWrapper = styled(Grid)(({ theme }) => ({
  paddingBottom: theme.spacing(3),
  boxSizing: 'border-box',
  [theme.breakpoints.down('sm')]: {
    paddingRight: 0,
    paddingBottom: theme.spacing(5),
  },
}))

export const OffertsWrapper = styled(Grid)(({ theme }) => ({
  boxSizing: 'border-box',
  position: 'relative',
  alignSelf: 'flex-start',
  flexWrap: 'wrap',
  [theme.breakpoints.down('sm')]: {
    paddingLeft: 0,
  },
}))

export const AppInfo = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(20.5, 19.5, 18, 19.5),
}))

export const ProductWrapper = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(3, 5.25),
}))

export const ProductOfferTop = styled(Product)(({ theme }) => ({
  marginBottom: theme.spacing(17),
}))
